import React, { useState } from 'react';
import { template as tmpl } from './DashboardContainer.tmpl';
import { connect } from 'react-redux';
import { switchCompany } from '../../redux/actions/appActions';

const DashboardContainerLogic = (props) => {
    const {
        firstname,
        lastname,
        activeCompany,
        companies = [],
        history
    } = props;

    const switchCompany = (company) => {
        props.switchCompany({
            company_id: company.id
        });
    };

    const navigate = (route, id, state) => {
        props.history.push({
            pathname: route,
            search: id,
            state: state
        });
    };

    const initProps = {
        navigate: navigate,
        firstname: firstname,
        lastname: lastname,
        activeCompanyName: activeCompany.name ? activeCompany.name : '',
        companies: companies
    };

    return (
        tmpl &&
        tmpl({ ...initProps, switchCompany: switchCompany })
    );
};

class DashboardContainer extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const initProps = {
            ...this.props
        };
        return <DashboardContainerLogic {...initProps} />;
    }
}

const mapStateToProps = (state) => {
    const { userReducer, companyReducer } = state;
    const { firstname, lastname } = userReducer;
    const { activeCompany, companies } = companyReducer;
    return {
        firstname: firstname,
        lastname: lastname,
        companies: companies,
        activeCompany: activeCompany
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        switchCompany: (data) => dispatch(switchCompany(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer);
